import type { ExtractRow } from "../shared/extractListTypes";
import {
  normalizeExtratoListItemDates,
  onlyDigits,
  pickSituacaoIdApi,
  resolveSituacaoExtratoParaLista,
} from "../shared/extractListUtils";

const resolveSolicitacaoId = (item: any): number | null =>
  item?.idSolicitacaoAvaliacao ??
  item?.solicitacaoId ??
  item?.idQuestionarioResposta ??
  null;

const mapItemToRow = (item: any, ano: number, index: number): ExtractRow => {
  const datas = normalizeExtratoListItemDates(item);
  const solicitacaoId = resolveSolicitacaoId(item);
  const idSindicato = item?.idSindicato ?? item?.sindicatoId ?? null;

  return {
    id: solicitacaoId ?? idSindicato ?? index + 1,
    cnpj: item?.cnpj ?? null,
    sigla: item?.sigla ?? null,
    nome: item?.nome ?? null,
    solicitacao: item?.solicitacao || "—",
    situacao: resolveSituacaoExtratoParaLista(item),
    situacaoId: pickSituacaoIdApi(item),
    envio: datas.envio ?? null,
    atualizacao: datas.atualizacao ?? null,
    questionario: solicitacaoId,
    idSindicato,
    solicitacaoId,
    ano,
    historicoHabilitado: !!solicitacaoId && solicitacaoId !== 0,
    rowKey: `${idSindicato ?? onlyDigits(item?.cnpj) ?? "x"}-${solicitacaoId ?? index}-${ano}`,
  };
};

/** Lista V2 (2026+): apenas solicitações retornadas pela API — sem merge com getAll. */
export const mapExtratoSolicitacoesToRows = (
  items: unknown[],
  ano: number,
): ExtractRow[] => {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => mapItemToRow(item, ano, index));
};
